import { StartingConstraints } from '../models';

export const STARTING_CONSTRAINTS: StartingConstraints = {
    coldCondition: 'ac',
    warmCondition: 'aw'
};


export const DEFAULT_AC = 2;
export const DEFAULT_AW = 1;
